import PagesLayout from "../../components/global/PagesLayout";
import PageHeader from "../../components/global/PageHeader";
import Breadcrumbs from "../../components/global/Breadcrumbs";
import Content from "../../components/termsConditions/Content";

const TermsConditions = () => {
  return (
    <PagesLayout>
      <PageHeader title="Terms & Conditions" />
      <Breadcrumbs title="Terms & Conditions" />
      <Content />
      <Breadcrumbs title="Terms & Conditions" />
    </PagesLayout>
  );
};

export default TermsConditions;
